export default "__VITE_ASSET__f2cd8864__"